import { dashboard } from "../libs/api-url";
import axios from "@/libs/axios";
class DashboardService {
  static async getCounts() {
    try {
      const { data } = await axios.get(dashboard.getCounts);
      return data;
    } catch (err) {
      throw err; // Re-throw the error for the caller to handle
    }
  }
  static async getUserChart(params) {
    try {
      const { data } = await axios.get(dashboard.getUserChart, {
        params,
      });
      return data;
    } catch (err) {
      throw err; // Re-throw the error for the caller to handle
    }
  }
}

export { DashboardService };
